import { createId } from '@paralleldrive/cuid2'
import { Rule } from 'antd/lib/form'

import { ImageCaptureBlock as ImageCaptureBlockType } from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

import { AttachmentUploader } from '@/components/form-components/AttachmentUploader'
import { useTemplateRenderer } from '@/context/templateRendererContext'
import { FileUploadResult } from '@/hooks/useAttachmentUpload'

import { AttachmentType, Resource } from 'types/api.graphql'

type Props = {
  block: ImageCaptureBlockType
  rules: Rule[]
}

export const ImageCaptureBlock: React.FC<Props> = ({ block, rules }) => {
  const { key, url } = block
  const {
    projectId,
    resource,
    config: { contextualDate },
  } = useTemplateRenderer()

  const fileList = url
    ? [
        {
          uid: block.attachmentId || createId(),
          name: block.caption,
          status: 'done',
          url,
          key,
          attachmentId: block.attachmentId,
        } as FileUploadResult,
      ]
    : []

  return (
    <CaptureBlockFormItem
      valuePropName="fileList"
      initialValue={fileList}
      rules={rules}
      block={block}
    >
      <AttachmentUploader
        projectId={projectId}
        attachmentType={AttachmentType.TemplateResponseMedia}
        attachmentResource={resource ?? Resource.TemplateResponse}
        attachmentSortDate={contextualDate}
        maxCount={1}
        multiple={false}
      />
    </CaptureBlockFormItem>
  )
}
